import { Box, BoxProps, CircularProgress } from "@mui/material";

export default function LoadingApiQuery({
    size = 40,
    extraParams = {}
}: LoadingApiQueryProps) {
    return (
        <Box {...extraParams} display="flex" justifyContent="center" py={3}>
            <CircularProgress size={size} />
        </Box>
    )
}

interface LoadingApiQueryProps {
    size?: number,
    extraParams?: BoxProps
}